import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LogOut, Activity, Cpu, Library, ShieldAlert, Trophy, Users, Building2 } from "lucide-react";
import { useClerk } from "@clerk/clerk-react";
import logo from "../../assets/Logo2.png";
import School from "../../assets/school.svg";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useClerk();

  const navItems = [
    { name: "Partner Schools", path: "/manage-schools", icon: School },
    { name: "School Directory", path: "/school-directory", icon: Library },
    { name: "Users", path: "/manage-users", icon: Users },
    { name: "Achievements", path: "/manage-achievements", icon: Trophy },
    { name: "Organizations", path: "/organizations", icon: Building2 },
    { name: "Public Sources", path: "/source-reviews", icon: ShieldAlert },
    { name: "Content Review", path: "/content-review", icon: ShieldAlert },
    { name: "Engagement", path: "/engagement", icon: Activity },
    { name: "AI Usage", path: "/ai-usage", icon: Cpu },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    // Relative path — Clerk navigates via window.location after clearing
    // the session, lands us back on the Platform-Admin sign-in surface.
    signOut({ redirectUrl: "/signin" });
  };

  return (
    <div className="flex flex-col fixed top-0 left-0 min-h-screen w-[230px] bg-blue-50 px-4 pb-3 font-Manrope">
      {/* Logo */}
      <div className="flex justify-center py-8">
        <img src={logo} alt="Logo" className="h-[25px] w-[130px]" />
      </div>

      {/* Nav items — icon can be either an SVG asset path (string, via Vite's
          default SVG-as-URL import) or a Lucide React component. We detect by
          string-vs-not because Lucide icons are forwardRef components, which
          are objects (not functions) — `typeof === "function"` mis-classified
          them and rendered the component reference into <img src>, producing
          the broken-image glyph. */}
      <nav className="flex-1 space-y-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const isImagePath = typeof item.icon === "string";
          const IconComponent = isImagePath ? null : item.icon;
          return (
            <button
              key={item.name}
              type="button"
              onClick={() => handleNavigation(item.path)}
              className={`w-full flex items-center gap-[8px] px-[12px] py-[10px] rounded-[8px] text-[16px] font-medium transition-colors ${
                isActive
                  ? "bg-primary text-white shadow-sm"
                  : "text-gray-600 hover:bg-blue-100"
              }`}
            >
              {isImagePath ? (
                <img
                  src={item.icon}
                  alt={item.name}
                  className={`w-5 h-5 ${isActive ? "brightness-0 invert" : ""}`}
                />
              ) : IconComponent ? (
                <IconComponent className={`w-5 h-5 ${isActive ? "text-white" : "text-gray-600"}`} />
              ) : null}
              <span>{item.name}</span>
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <button
        type="button"
        onClick={handleLogout}
        className="mb-4 flex items-center gap-3 px-3 py-2 rounded-[8px] text-[16px] text-gray-600 font-medium font-['Plus Jakarta Sans'] hover:text-red-500 transition-colors"
      >
        <LogOut size={18} />
        <span>Logout</span>
      </button>
    </div>
  );
};

export default Sidebar;
